import React from 'react';
import { connect } from 'react-redux';
import ViewerOverlay from '../ViewerOverlays/ViewerOverlay';
import Resizer from './Resizer';

const ViewerWrapper = (Component) => {
	const WrappedImage = ({ pageToDisplay, pages, fieldToBeUpdated, withFormFields, updateDocumentsList, diva }) => {
		const { actual, preview } = pageToDisplay;
		const displayedPage = preview ?? actual;
		const showPerviewOverlay = pageToDisplay.hasOwnProperty('preview');
		const isDeleted = pages[displayedPage]?.isDeleted;
		const mixPages = {
			...pages,
			...diva?.divaOriginalImages
		}

		return (
			<div className='d-flex modal-viewer p-0 position-relative h-100 dynamic-width'>
				<Resizer />
				<div className='position-relative my-auto w-100 mh-100 overflow-auto scrollbar'>
					<div className='position-relative'>
						{(showPerviewOverlay || isDeleted) && <ViewerOverlay page={displayedPage} showPerviewOverlay={showPerviewOverlay} isDeleted={isDeleted} updateDocumentsList={updateDocumentsList} />}
						<Component displayedPage={displayedPage} fieldToBeUpdated={fieldToBeUpdated} withFormFields={withFormFields} mixPages={mixPages} />
					</div>
				</div>
			</div>
		);
	};

	/**
	 * Take the id of saved in redux document and return it
	 * in components props.
	 */
	const mapStateToProps = ({ savedDocument: { pages, diva } }) => ({ pages, diva });

	return connect(mapStateToProps)(WrappedImage);
};

export default ViewerWrapper;
